/**
 * @generated SignedSource<<32a2f09f1e44f0dc7a9a6d1e0112d8cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthenticationModalMethods_authenticationConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthenticationModalDisplay",
      "kind": "LinkedField",
      "name": "authenticationModal",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayOpenid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displaySaml",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displaySignIn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displaySignUp",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SsoSamlAuthenticationConfig",
      "kind": "LinkedField",
      "name": "samlAuthServices",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AuthenticationSamlForm_samlAuth"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SsoOpenidAuthenticationConfig",
      "kind": "LinkedField",
      "name": "openidAuthServices",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AuthenticationOpenidForm_openidAuth"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuthenticationAnonymousUserForm_authenticationConfig"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuthenticationSignIn_authenticationConfig"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuthenticationSignUp_authenticationConfig"
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};
})();

node.hash = "1d7afc5d8f00486ee0b2e8ff57bac76f";

module.exports = node;
